<template>
  <b-overlay
    id="overlay-background"
    :show="currencySettingLoader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="5"
        lg="5"
        offset-lg="3"
        class="fields-container"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <!-- form -->
            <b-form>
              <b-row>
                <b-col sm="12">
                  <b-form-group
                    label="Module"
                    label-for="module"
                  >
                    <v-select
                      v-model="currencyselected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="currencyOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="currencysettings"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                block
                variant="primary"
                @click="postCurrencySettingValues"
              >
                Save
              </b-button>
            </b-form>
          <!--/ form -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import { required } from '@validations'
import axios from '@axios'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
    BButton,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currencySettingLoader: false,
      currencyselected: 'DKK',
      currencyOptions: [
        { label: 'DKK', value: 'DKK' },
        { label: 'EURO', value: 'EUR' },
      ],
    }
  },
  watch: {
    settings: {
      handler() {
        this.mapValues()
      },
    },
    // role: {
    //   handler(selected) {
    //     this.settingsData(selected)
    //   },
    // },
  },
  created() {
    // this.settingsData('communication')
    // this.mapValues()
  },
  methods: {
    mapValues() {
      const item = this.settings.filter(word => word.key === 'default_currency')
      if (item.length > 0) {
        this.currencyselected = item[0].value
      }
    },
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.currencySettingLoader = false
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
    postCurrencySettingValues() {
      this.currencySettingLoader = true
      const obj = [
        {
          key: 'default_currency',
          value: this.currencyselected,
        },
      ]
      axios.post('user-settings/save', obj).then(response => {
        if (response.status) {
          localStorage.setItem('defaultCurrency', this.currencyselected)
          this.currencySettingLoader = false
          this.makeSuccessToast()
        }
      }).catch(error => {
        // if (err.response.data.message) {
        //   this.alertErrors.push(err.response.data.message)
        // }
        this.makeFailureToast(error)
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.fields-container {
  border: 2px solid #f8f8f8;
  border-radius: 10px;
}
</style>
